module.exports = __webpack_public_path__ + "img/food-5.ca2f2d57.jpg";